import { textStyles } from '@cosuno/cosuno-ui';
import styled from 'styled-components';

export const PlansWrapper = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 1090px;
`;

export const PricingItemsTitle = styled.div`
  ${textStyles.titleSmall500};
  margin: 30px 0 20px;
  &:first-child {
    margin-top: 0;
  }
`;

export const PricingModalAddonsTitle = styled.div`
  ${textStyles.titleSmall500};
  margin: 20px 0;
`;

export const PricingPlansModalContent = styled.div`
  padding: 30px;
`;
